import { apiRequest } from "./common";

const createCodingSkill = async (data) => {
    const response = await apiRequest('post', '/skill', data);
    return response.data;
};

const updateCodingSkill = async (id, data) => {
    const response = await apiRequest('put', `/skill/${id}`, data);
    return response.data;
};

const deleteCodingSkill = async (id) => {
    const response = await apiRequest('delete', `/skill/${id}`);
    return response.data;
};

const getCodingSkills = async (studentId, currentGrade) => {
    const response = await apiRequest('get', `/skill/by-student/${studentId}${currentGrade ? `?studentGrade=${currentGrade}`: ''}`);
    return response.data;
};

export {
    createCodingSkill,
    updateCodingSkill,
    deleteCodingSkill,
    getCodingSkills
}